export class PageForm {

    // onBeforeUnloadCallback = undefined;
    validateFormCallback = [];
    preSubmitCallback = [];
    tag = "main";
    config = {
        method: "POST"
    };
    staticData = undefined;
    data = [];
    constructor(tag, config, data = {}, validateCallback = undefined, presubmitCallback = undefined, onBeforeUnload = undefined) {

        this.tag = tag;

        Object.assign(this.config, config);

        this.registerValidateCallback(validateCallback);
        this.registerPresubmitCallback(presubmitCallback);
        // this.onBeforeUnloadCallback = onBeforeUnload;

        $(`.js-page-form[data-tag="${this.tag}"]`).on('input', function (e) {
            if (typeof (window.onbeforeunload) !== 'function')
                window.onbeforeunload = function (e) {
                    e = e || window.event;

                    var msg = "Any unsaved changed will be discarded?";

                    // For IE and Firefox prior to version 4
                    if (e) {
                        e.returnValue = msg;
                    }

                    // For Safari
                    return msg;
                };
        });


        this.staticData = data;
    };

    registerValidateCallback(callback) {
        if (typeof (callback) === 'function')
            this.validateFormCallback.push(callback);
    };
    registerPresubmitCallback(callback) {
        if (typeof (callback) === 'function')
            this.preSubmitCallback.push(callback);
    };

    submit(formTag) {


        for (let index = 0; index < this.preSubmitCallback.length; index++) {
            const cb = this.preSubmitCallback[index];
            cb(this.tag, this);
        }

        //compile data
        let data = {};

        Object.assign(data, this.staticData);


        //collect all form data
        $(`.js-page-form[data-tag="${this.tag}"]`).each((idx, e) => {
            let name = $(e).attr('name');
            let value = $(e).val();
            let type = $(e).attr('type');

            let checked = $(e).is(':checked');


            if ((type === 'radio' || type === 'checkbox') && !checked)
                return;

            if (typeof (name) === 'undefined' || typeof (value) === 'undefined')
                return;

            data[name] = value;
        });

        this.data = data;

        let validated = true;

        for (let index = 0; index < this.validateFormCallback.length; index++) {
            const cb = this.validateFormCallback[index];
            if (!cb(this.tag, data, this)) {
                validated = false;
                break;
            }

        }
        if (!validated)
            return;


        let form = $('<form>');
        form.attr('method', this.config.method);
        form.attr('action', this.config.url);

        Object.entries(data).forEach(([key, value]) => {
            let input = $('<input type="hidden">');
            input.attr('name', key);
            input.val(value);
            form.append(input);
        });

        console.log(data);

        $('body').append(form);

        window.onbeforeunload = null;
        form.trigger('submit');
        form.remove();


        // console.log($(`.js-page-form[data-tag="${this.tag}"]`));
    };
    checkErrors(){
        let _this = this;
        let errors = this.config.errors;
        if(typeof(errors) === 'undefined')
            return;
        console.log(errors);
        Object.entries(errors).forEach(([key,message]) =>{

            //mark all error
            $(`.js-page-form[data-tag="${_this.tag}"]`).each((idx, e) => {
                let name = $(e).attr('name');
                if(typeof(name) === 'undefined' || name != key)
                    return;

                $(e).addClass('hasError');
                let errorMessage = $('<div class="form-error-message">');
                errorMessage.html(message[0]);
                $(e).after(errorMessage);

            });
        });
    } 
}